import * as React from 'react';
import { Provider } from 'react-redux';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { Responsive, UiKitRoot } from '@cian/ui-kit';
import { IApplicationContext } from '../../types/app';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer, PageContainerMobile } from '../PageContainer';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={reduxStore.getState().config.deviceType}>
          <Provider store={reduxStore}>
            <MicrofrontendProvider registry={context.microfrontendsRegistry}>
              <Responsive desktop>
                <PageContainer />
              </Responsive>
              <Responsive tablet phone>
                <PageContainerMobile />
              </Responsive>
            </MicrofrontendProvider>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
